<div class="text-clipboard-wrapper">
    <div [lgLongText]="text() || '-'" class="crop-text"></div>
    <lg-icon
        *ngIf="text()"
        icon="icon-copy"
        [clickable]="true"
        type="highlighted"
        (click)="_copyText($event)"
        [lgSimpleTooltip]="'.CopyToClipboard' | lgTranslate"
    ></lg-icon>
</div>
